"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toJsonContent = toJsonContent;
function toJsonContent(componentList) {
    const json = componentList.asset.toJson();
    json.asset = componentList.fileInfo.toJson();
    json.chunks = componentList.chunks.map((c) => c.toJson());
    json.nodes = componentList.nodes.map((n) => n.toJson());
    json.items = componentList.items.map((i) => i.toJson());
    json.attributes = componentList.attributes.map((a) => a.toJson());
    json.typeHints = componentList.typeHints.map((t) => t.toJson());
    json.accessors = componentList.accessors.map((a) => a.toJson());
    json.bufferViews = componentList.bufferViews.map((v) => v.toJson());
    json.buffers = componentList.buffers.map((b) => b.toJson());
    return json;
}
//# sourceMappingURL=ISdtfComponentList.js.map